module.exports = __webpack_public_path__ + "media/src/images/process_fax1-91f97dceab707b1cd1ed751a71b8ab70.png";